import { useEffect, useState } from "react";
import { useFormsContext } from "../context/formsContext";
import Grid2 from "@mui/material/Grid2";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiSelect-root": {
			backgroundColor: "#FFF",
		},
	},
	inputLabel: {
		position: "absolute",
		top: -16,
		left: 8,
		fontSize: 11.3,
		backgroundColor: "#FFF",
		color: "#0000008A",
		width: "auto",
		height: "auto",
		zIndex: 100,
		padding: "0 3px",
		borderRadius: 3,
		fontWeight: 400,
		lineHeight: "1.1876em",
		letterSpacing: "0.04208em",
		fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
	},
}));

export const FormAssetSelectorModal = () => {
	const {
		state: { formsForUser },
		actions: { setNewInstanceFormId, setNewInstanceAssetId },
	} = useFormsContext();
	const [selectedValue, setSelectedValue] = useState<string>("");

	const classes = useStyles();

	const handleSelectChange = (event: any) => {
		const selected = event.target.value as string;
		setSelectedValue(selected);
		const [formId, assetId] = selected.split("-");
		setNewInstanceFormId(formId);
		setNewInstanceAssetId(assetId);
	};
	useEffect(() => {
		if (formsForUser[0] && formsForUser[0].FormId && formsForUser[0].AssetId) {
			setSelectedValue(`${formsForUser[0].FormId}-${formsForUser[0].AssetId}`);
			setNewInstanceFormId(formsForUser[0].FormId);
			setNewInstanceAssetId(formsForUser[0].AssetId);
		}
	}, []);

	return (
		<div
			className={classes.root}
			style={{ position: "relative", marginTop: "24px" }}
		>
			<p className={classes.inputLabel}>Form - Asset</p>
			<Select
				variant="outlined"
				margin="dense"
				labelId="demo-simple-select-label"
				id="demo-simple-select"
				value={selectedValue}
				onChange={handleSelectChange}
				style={{ minWidth: "100%" }}
			>
				{formsForUser.map((form) => (
					<MenuItem
						key={`logId-${form.FormId}-${form.AssetId}`}
						value={`${form.FormId}-${form.AssetId}`}
					>
						<Grid2 container alignItems="center">
							{`${form.FormName} - ${form.AssetName}`}
						</Grid2>
					</MenuItem>
				))}
			</Select>
		</div>
	);
};
